const ToolUsageAccuracyStatus = {
  /** Tool wasn't used but should've been used. */
  UnusedIncorrect: "unused_incorrect",
  /** Tool wasn't used and wasn't expected to be used. */
  UnusedCorrect: "unused_correct",
  /** Tool was used, but an error occurred. */
  UsedFailed: "used_failed",
  /** Tool was used incorrectly. The input was wrong or the output was not used correctly. */
  UsedIncorrect: "used_incorrect",
  /** Tool was used correctly. */
  UsedCorrect: "used_correct"
};
const allToolUsageAccuracyStatuses = [
  ToolUsageAccuracyStatus.UnusedIncorrect,
  ToolUsageAccuracyStatus.UnusedCorrect,
  ToolUsageAccuracyStatus.UsedFailed,
  ToolUsageAccuracyStatus.UsedIncorrect,
  ToolUsageAccuracyStatus.UsedCorrect
];
function checkIsToolUsageAccuracyStatus(status) {
  return allToolUsageAccuracyStatuses.some((s) => s === status);
}
const inaccurateToolUsageStatuses = [
  ToolUsageAccuracyStatus.UnusedIncorrect,
  // Incorrectly unused
  ToolUsageAccuracyStatus.UsedFailed,
  // Failed usage
  ToolUsageAccuracyStatus.UsedIncorrect
  // Incorrect usage
];
function checkToolUsageAccuracyStatusIsInaccuracy(status) {
  return inaccurateToolUsageStatuses.some((s) => s === status);
}
const usedToolUsageStatuses = [
  ToolUsageAccuracyStatus.UnusedIncorrect,
  // Should've been used
  ToolUsageAccuracyStatus.UsedFailed,
  // Was used
  ToolUsageAccuracyStatus.UsedIncorrect,
  // Was used
  ToolUsageAccuracyStatus.UsedCorrect
  // Was used
];
function checkToolUsageAccuracyStatusIsUsage(status) {
  return usedToolUsageStatuses.some((s) => s === status);
}
export {
  ToolUsageAccuracyStatus,
  checkIsToolUsageAccuracyStatus,
  checkToolUsageAccuracyStatusIsInaccuracy,
  checkToolUsageAccuracyStatusIsUsage,
  inaccurateToolUsageStatuses,
  usedToolUsageStatuses
};
//# sourceMappingURL=toolUsageAccuracy.js.map
